import { SharedAngular } from '@Client/@types/sharedAngular';
import { PdfHelper } from '@Client/runner.flow/runner.flow/runner.flow.service';
import angular, { ILocationService, ITimeoutService } from 'angular';

class RunnerPrintFlowController {
  public static $inject = [
    'PPDFService',
    '$timeout',
    'runnerFlowsFormatter',
    'flowApiService',
    '$location',

    '$q',
    'sessionService',
    'avatarService',
    'dateService',
    'APP_CONFIG',
    '$http',
    'lodashService',
    '$sce',
    'flowinglyConstants',
    'runnerFlowService',
    'commentApiService'
  ];

  constructor(
    private PPDFService: PPDFService,
    private $timeout: ITimeoutService,
    private runnerFlowsFormatter: RunnerFlowsFormatterService,
    private flowApiService: FlowApiService,
    private $location: ILocationService,

    private $q,
    private sessionService,
    private avatarService,
    private dateService,
    private APP_CONFIG,
    private $http,
    private lodashService,
    private $sce,
    private flowinglyConstants,
    private runnerFlowService: RunnerFlowService,
    private commentApiService: SharedAngular.CommentApiService
  ) {
    const flowId = this.$location.search().id;
    this.flowApiService.getFlowById(flowId, false).then((flowForUser) => {
      const formattedFlow = this.runnerFlowsFormatter.formatFlow(flowForUser);
      return PdfHelper.generatePdfPayload(formattedFlow, this).then((data) => {
        return this.PPDFService.generatePpdfInCurrentWindow(
          'Client/runner/services/pdf-templates/flow-to-ppdf.html',
          data
        ).then(() => {
          this.$timeout(() => {
            if (typeof hiqPdfConverter_startConversion === 'function') {
              hiqPdfConverter_startConversion();
            }
          }, 1000);
        });
      });
    });
  }
}
angular
  .module('flowingly.runner.print')
  .controller('runnerPrintFlowController', RunnerPrintFlowController);
